import React, { useEffect, useState } from "react";
import { apiClient } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { QRCodeSVG } from "qrcode.react";
import { Plus, Trash2 } from "lucide-react";

export default function EquipmentQR() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ name: "", serial: "", category: "tool", status: "available" });
  const load = () => apiClient().get("/equipment").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    try { await apiClient().post("/equipment", form); toast.success("Equipment added"); setForm({ name: "", serial: "", category: "tool", status: "available" }); load(); }
    catch { toast.error("Failed"); }
  };
  const del = async (id) => { await apiClient().delete(`/equipment/${id}`); load(); };

  return (
    <div className="space-y-6 fade-in-up" data-testid="equipment-page">
      <div>
        <h1 className="font-display text-5xl mt-1">QR Equipment Registry</h1>
      </div>

      <form onSubmit={add} className="border border-border bg-card p-5 grid md:grid-cols-5 gap-3" data-testid="equip-form">
        <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="equip-name" aria-label="Name" className="border border-border bg-background px-3 py-2 text-sm" />
        <input required value={form.serial} onChange={(e) => setForm({ ...form, serial: e.target.value })} data-testid="equip-serial" aria-label="Serial number" className="border border-border bg-background px-3 py-2 text-sm" />
        <select value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} data-testid="equip-category" className="border border-border bg-background px-3 py-2 text-sm">
          {["tool", "vehicle", "heavy-machinery", "ppe"].map(o => <option key={o}>{o}</option>)}
        </select>
        <select value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })} data-testid="equip-status" className="border border-border bg-background px-3 py-2 text-sm">
          {["available", "in-use", "maintenance"].map(o => <option key={o}>{o}</option>)}
        </select>
        <button data-testid="equip-add-btn" className="btn-sharp inline-flex items-center justify-center gap-2 bg-primary text-primary-foreground px-4 py-2"><Plus className="h-4 w-4" /> Add</button>
      </form>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
        {items.length === 0 && <div className="text-sm text-muted-foreground col-span-full">No equipment yet.</div>}
        {items.map((it) => (
          <div key={it.id} className="border border-border bg-card p-4 flex gap-4" data-testid={`equip-card-${it.id}`}>
            <div className="p-2 bg-white border border-border">
              <QRCodeSVG value={it.qr_code} size={96} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="mono text-[10px] uppercase tracking-widest text-muted-foreground">{it.category}</div>
              <div className="font-heading text-lg truncate">{it.name}</div>
              <div className="mono text-xs text-muted-foreground">SN: {it.serial}</div>
              <div className="mono text-xs text-primary mt-1">{it.qr_code}</div>
              <div className="mt-2 mono text-[10px] uppercase tracking-widest">{it.status}</div>
              <button onClick={() => del(it.id)} data-testid={`equip-del-${it.id}`} className="mt-2 text-muted-foreground hover:text-destructive text-xs inline-flex items-center gap-1">
                <Trash2 className="h-3 w-3" /> Remove
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
